import { render, staticRenderFns } from "./ResetPasswordFinish.vue?vue&type=template&id=2822399e"
import script from "./ResetPasswordFinish.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports